import React from 'react';

const CatalogContext = React.createContext('catalog_context');

export default CatalogContext;
